import { useState } from "react"
import { useSelector } from "react-redux"
import { selectTranslations } from "../../../App/i18n/i18nSlice"
import { CloseIcon, PostsCommentsTabIcon } from "../../Shared/Components/SvgIcons"

type RoomComposerFabProps = {
    onCreatePost: () => void
    onCreateComment: () => void
}

function RoomComposerFab(props: RoomComposerFabProps) {
    const translation = useSelector(selectTranslations)
    const [isOpen, setIsOpen] = useState(false)

    const closeMenu = () => setIsOpen(false)

    const onCreatePost = () => {
        closeMenu()
        props.onCreatePost()
    }

    const onCreateComment = () => {
        closeMenu()
        props.onCreateComment()
    }

    return (
        <>
            {isOpen && <button type="button" className="room-layout__compose-fab-backdrop" aria-label="Aktionen schließen" onClick={closeMenu} />}
            <div className={`room-layout__compose-fab-shell ${isOpen ? "room-layout__compose-fab-shell--open" : ""}`}>
                {isOpen && (
                    <div className="room-layout__compose-fab-menu" role="menu" aria-label="Erstellen Aktionen">
                        <button type="button" className="room-layout__compose-fab-option" onClick={onCreatePost}>
                            <span className="room-layout__compose-fab-option-text">{translation.createPost}</span>
                        </button>
                        <button type="button" className="room-layout__compose-fab-option" onClick={onCreateComment}>
                            <span className="room-layout__compose-fab-option-text">{translation.writeComment}</span>
                        </button>
                    </div>
                )}

                <button
                    type="button"
                    className={`room-layout__compose-fab ${isOpen ? "room-layout__compose-fab--open" : ""}`}
                    aria-label={isOpen ? "Aktionen schließen" : "Erstellen"}
                    aria-haspopup="menu"
                    aria-expanded={isOpen}
                    onClick={() => setIsOpen((value) => !value)}
                >
                    {isOpen ? <CloseIcon /> : <PostsCommentsTabIcon />}
                </button>
            </div>
        </>
    )
}

export default RoomComposerFab